import { Address } from "viem"
import { Config } from "wagmi"
import { getPublicClient } from "wagmi/actions"

import { voterAbi } from "@/domains/abis"
import { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"

export const getCorrectBribeAddress = async (
  bribeType: "vote" | "lp",
  selectedPool: MinimalPoolStore | null,
  config: Config,
  voterAddress: Address,
): Promise<Address> => {
  if (!selectedPool?.gaugeAddress) {
    throw new Error("No gauge address provided")
  }

  const client = getPublicClient(config)
  if (!client) throw new Error("Failed to get public client")

  const gaugeAddress = selectedPool.gaugeAddress.toViemAddress()

  if (bribeType === "vote") {
    // For vote bribes, fetch the bribe address from the voter contract
    const bribeAddress = await client.readContract({
      address: voterAddress,
      abi: voterAbi,
      functionName: "bribes",
      args: [gaugeAddress],
    })

    if (!bribeAddress || bribeAddress === "0x0000000000000000000000000000000000000000") {
      throw new Error("No bribe address found for gauge")
    }

    return bribeAddress as Address
  }

  // For LP bribes, check if there's a custom gauge, otherwise use the gauge address
  const customGauge = await client.readContract({
    address: voterAddress,
    abi: voterAbi,
    functionName: "customGauges",
    args: [gaugeAddress],
    account: "0x0000000000000000000000000000000000000000" as Address,
  })

  return customGauge === "0x0000000000000000000000000000000000000000"
    ? gaugeAddress // Use gauge address for LP bribes
    : (customGauge as Address) // Use custom gauge if it exists
}
